/********************************************************
 *                                                      *
 * ----------------- EVENT LISTENERS ------------------ *
 *                                                      *
 ********************************************************/

// import { getElements } from "./utils";
import { DATA_NAMES, EVENT_NAMES } from './constants';
import * as Handlers from './Handlers';

// --- Set Event Listeners //
export default function setEventListeners() {
    ctaClickEventListener();
    // formEventListener();
    // videoMarketingEventListener();
}

// --- CTA Click Event Listener //
function ctaClickEventListener() {
    const ctaElements = document.querySelectorAll(DATA_NAMES.CTA);
    if (ctaElements?.length === 0) {
        return;
    }
    try {
        ctaElements?.forEach((element: Element) => {
            element.removeEventListener('click', Handlers.handleCtaClickEvent);
            element.addEventListener('click', (evt) => {
                Handlers.handleCtaClickEvent(evt);
            });
        });
    } catch (err) {
        throw new Error(err);
    }
}

// --- Form Event Listener //
function formEventListener() {
    const formElements = document.querySelectorAll(DATA_NAMES.FORM);
    if (formElements?.length === 0) {
        return;
    }
    try {
        formElements?.forEach((element: Element) => {
            element.addEventListener('submit', (evt) => {
                Handlers.handleMarketingOptInSubmitEvent(evt);
            });
        });
    } catch (err) {
        throw new Error(err);
    }
}

// --- Video Event Listener // TODO Adjust for React app videos
// function videoMarketingEventListener() {
//     const {
//         VIDEO: {
//             marketing: { play, ended },
//         },
//     } = EVENT_NAMES;
//     const { videoElements } = getElements();
//     if (videoElements?.length === 0) {
//         return;
//     }
//     try {
//         videoElements?.forEach((element: HTMLElement) => {
//             // TODO: get title and description from data attributes
//             let properties = {
//                 title: "Learm More About the App",
//                 description: "This video introduces the app to new customers",
//                 keywords: ["app", "marketing", "acquisition"],
//             };
//             // Play event
//             Handlers.handleVideoPlayEvent(element, play, properties);
//             // Pause event
//             Handlers.handleVideoPauseEvent(element, ended, properties);
//             // Ended event
//             Handlers.handleVideoEndedEvent(element, ended, properties);
//         });
//     } catch (err) {
//         throw new Error(err);
//     }
// }
